import { numberFunctions } from "./numberFunctions";

const nameFunctions = {
  getCompactName: (name: string) => {
    if (!name) return "";
    if (name?.length > 15 && name?.includes(" ")) {
      const nameSplit = name.split(" ");
      const lastName = nameSplit[nameSplit.length - 1];
      nameSplit.pop();
      let partialName = "";
      nameSplit.map((item) => {
        partialName += ` ${item[0]}`;
      });
      partialName = `${partialName} ${lastName}`;
      return partialName.trim();
    }
    return name;
  },
  getFirstName: (name: string) => {
    if (!name) return "";
    if (name?.includes(" ")) {
      const nameSplit = name.split(" ");
      const firstName = nameSplit[0];
      const lastName = nameSplit[nameSplit.length - 1];
      return firstName?.length > 3 ? firstName : lastName;
    }
    return name;
  },
  getIconName: (name: string) => {
    if (!name) return "";
    const nameSplit = name.split(" ");
    if (nameSplit.length > 1 && nameSplit[1]) {
      let partialName = `${nameSplit[0][0] || ""}${nameSplit[1][0] || ""}`;
      return partialName.toUpperCase() || "";
    }
    return name[0]?.toUpperCase() + (name[1]?.toUpperCase() || "");
  },
  getLastFourChar: (string: string) => {
    return string?.substr(string.length - 4);
  },
  getRandomName: (length: number) => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  getRandomEmail: () => {
    const chars = "abcdefghijklmnopqrstuvwxyz1234567890";
    let string = "";
    for (var ii = 0; ii < 15; ii++) {
      string += chars[Math.floor(Math.random() * chars.length)];
    }
    const finalEmail = `${string}@${nameFunctions.getRandomName(5)}.com`;
    return finalEmail;
  },
};

export default nameFunctions;
